export default {"src":"/_next/static/media/email.2f6e0125.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};